// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2-Q7U","title":"InfoRow_title__1MMIy"};